<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/setup/cataloge-mapping/sales" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>
              <td
                v-if="
                  broadcaster &&
                  broadcaster.salesCatalogeData &&
                  broadcaster.salesCatalogeData.name
                "
              >
                {{ broadcaster.salesCatalogeData.name }}
              </td>
            </h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deletesalescatalogePopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <div class="dual-listbox-wrapper">
              <div class="listbox">
                <div class="listbox-header">
                  <h6 class="text-left font-bold">
                    {{ $t("setup.label.AvailablePlans") }}
                  </h6>
                  <input
                    v-model="searchSource"
                    :placeholder="$t('setup.label.Search')"
                    class="border search-box rounded p-2 w-1/2"
                  />
                </div>
                <ul class="listbox-body">
                  <li
                    v-for="plan in filteredSourcePlans"
                    :key="plan.id"
                    :class="[
                      'listbox-item',
                      selectedSourcePlans === plan.id ? 'active' : '',
                    ]"
                  >
                      {{ plan.planCode }}
                  </li>
                </ul>
              </div>
        
              <div class="arrow-buttons">
                <button
                  class="arrow-button"
                  :disabled="!selectedSourcePlans"
                  @click="moveToTarget"
                >
                  <feather-icon icon="ArrowRightIcon" svgClasses="text-dark" />
                </button>
                <button
                  class="arrow-button"
                  :disabled="!selectedTargetPlans"
                  @click="moveToSource"
                >
                  <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                </button>
              </div>
        
              <div class="listbox">
                <div class="listbox-header">
                  <h6 class="text-left font-bold">
                    {{ $t("setup.label.SelectedPlans") }}
                  </h6>
                  <input
                    v-model="searchTarget"
                    :placeholder="$t('setup.label.Search')"
                    class="border search-box rounded p-2 w-1/2"
                  />
                </div>
                <ul class="listbox-body">
                  <li
                    v-for="plan in filteredTargetPlans"
                    :key="plan.id"
                    :class="[
                      'listbox-item',
                      selectedTargetPlans === plan.id ? 'active' : '',
                    ]"
                  >
                      {{ plan.planCode }}
                  </li>
                </ul>
              </div>
            </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deletesalescatalogePopup"
      :title="$t('setup.label.SalesCataloge')"
      @deletePressed="deletesalescataloge()"
      @cancelPressed="deletesalescatalogePopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
export default {
  data() {
    return {
      id: "",
      viewBroadcaster: {},
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      deletesalescatalogePopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
      plansInit: {},
      selectedSourcePlans: null,
      selectedTargetPlans: null,
      searchSource: "",
      searchTarget: "",
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      broadcaster: (state) => state.catalogueMapping.viewSalesCatalogeList,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    filteredSourcePlans() {
      if (this.plansInit && this.plansInit.sourcePlans) {
        return this.plansInit.sourcePlans.filter(
          (d) =>
            d.planCode.toLowerCase().includes(this.searchSource.toLowerCase())
        );
      } else {
        return null;
      }
    },
    filteredTargetPlans() {
      if (this.plansInit && this.plansInit.targetPlans) {
        return this.plansInit.targetPlans.filter(
          (d) =>
            d.planCode.toLowerCase().includes(this.searchTarget.toLowerCase())
        );
      } else {
        return null;
      }
    },
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    editData(id) {
      this.$router.push({ name: "Edit Sales Cataloge", params: { id: id } });
    },
    async deletesalescataloge() {
      this.deletesalescatalogePopup = false;
      await this.$store.dispatch(
        "catalogueMapping/deletesalescatalogeAction",
        this.id
      );
      this.$router.push(`/setup/cataloge-mapping/sales`);
    },

    async viewSalesCataloge() {
      try {
        await this.$store.dispatch(
          "catalogueMapping/setviewSalesCataloge",
          this.id
        );
        this.viewBroadcaster = this.broadcaster;
        this.initializePlans();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    moveToTarget() {
      if (!this.selectedSourcePlans) return;

      const selectedDiscount = this.plansInit.sourcePlans.find(
        (discount) => discount.id === this.selectedSourcePlans
      );

      if (selectedDiscount) {
        this.plansInit.targetPlans.push(selectedDiscount);
        this.plansInit.sourcePlans =
          this.plansInit.sourcePlans.filter(
            (discount) => discount.id !== this.selectedSourcePlans
          );
        this.selectedSourcePlans = null;
      }
    },

    moveToSource() {
      if (!this.selectedTargetPlans) return;

      const selectedDiscount = this.plansInit.targetPlans.find(
        (discount) => discount.id === this.selectedTargetPlans
      );

      if (selectedDiscount) {
        this.plansInit.sourcePlans.push(selectedDiscount);
        this.plansInit.targetPlans =
          this.plansInit.targetPlans.filter(
            (discount) => discount.id !== this.selectedTargetPlans
          );
        this.selectedTargetPlans = null;
      }
    },
    initializePlans() {
     const allPlans = (this.broadcaster && this.broadcaster.plans) || [];
     const selectedPlans = this.broadcaster && this.broadcaster.selectedPlans ? [...this.broadcaster.selectedPlans] : [];

  if (selectedPlans.length > 0) {

    const targetPlans = selectedPlans

    const sourcePlans = allPlans

    this.$set(this, "plansInit", {
      sourcePlans,
      targetPlans,
    });
  } else {
    this.$set(this, "plansInit", {
      sourcePlans: [...allPlans],
      targetPlans: [],
    });
  }

  this.selectedSourcePlans = null;
  this.selectedTargetPlans = null;
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    await this.viewSalesCataloge();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
  .dual-listbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
}
.listbox {
  width: -webkit-fill-available;
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  background: #fff;
  display: flex;
  flex-direction: column;
}
.listbox-header {
  background-color: #2e68b266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.listbox-body {
  overflow-y: auto;
  flex-grow: 1;
  margin: 0;
  padding: 10px;
  list-style: none;
}
.listbox-item {
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
}
.listbox-item:hover {
  background-color: #f0f8ff;
}
.listbox-item.active {
  background-color: #e2e9f5;
  font-weight: bold;
}
.arrow-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.arrow-button {
  padding: 8px;
  border: none;
  background-color: #eee;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 0;
}
.arrow-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
